// SQL — Supabase'de çalıştırılacak:
// ALTER TABLE musteriler ADD COLUMN IF NOT EXISTS vergi_no varchar;
// ALTER TABLE depo ADD COLUMN IF NOT EXISTS brut_kg numeric;
// ALTER TABLE depo ADD COLUMN IF NOT EXISTS fatura_tarihi date;
//
// CREATE TABLE IF NOT EXISTS ihracat_sihirbaz (
//   id uuid DEFAULT gen_random_uuid() PRIMARY KEY,
//   sefer_id uuid REFERENCES seferler(id),
//   depo_id uuid REFERENCES depo(id),
//   kap_adedi integer,
//   net_kg numeric,
//   brut_kg numeric,
//   alici_ad varchar,
//   alici_adres text,
//   alici_vergi_no varchar,
//   alici_telefon varchar,
//   created_at timestamp DEFAULT now(),
//   updated_at timestamp DEFAULT now(),
//   UNIQUE(sefer_id, depo_id)
// );

import React, { useState, useEffect, useCallback } from 'react';
import { supabase } from './supabase';
// xlsx CDN'den yükleniyor (public/index.html) — window.XLSX olarak kullanılır
import {
  DndContext, closestCenter, PointerSensor, TouchSensor,
  useSensor, useSensors,
} from '@dnd-kit/core';
import {
  SortableContext, verticalListSortingStrategy,
  useSortable, arrayMove,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const GONDERICI = {
  ad: 'BYR SWORD LOJİSTİK İTHALAT İHRACAT SAN. VE TİC. LTD.ŞTİ.',
  adres: 'ORUÇ REİS MAH. TEKSTİLKENT CAD. TEKSTİLKENT G1 BLOK NO: 10 AB İÇ KAPI NO: Z-31 ESENLER / İSTANBUL',
  vergiDairesi: 'ATIŞALANI (034291)',
  vergiNo: '195 089 8445',
};

const ADIMLAR = ['Sefer Seç', 'Fatura & Alıcı', 'Çeki Listesi'];

// ── Sürükle-bırak satır ─────────────────────────────────────────
function SortableRow({ id, children }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id });
  return (
    <tr
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.45 : 1,
        background: isDragging ? '#EEF4FF' : undefined,
      }}
      {...attributes}
    >
      {children(listeners)}
    </tr>
  );
}

// ── Adım göstergesi ─────────────────────────────────────────────
function AdimGostergesi({ aktif }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '28px' }}>
      {ADIMLAR.map((ad, i) => {
        const tamamlandi = i < aktif;
        const simdiki = i === aktif;
        return (
          <React.Fragment key={i}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>
              <div style={{
                width: '34px', height: '34px', borderRadius: '50%', display: 'flex',
                alignItems: 'center', justifyContent: 'center', fontWeight: '700', fontSize: '14px',
                background: tamamlandi ? '#3B6D11' : simdiki ? '#0D3B7A' : '#e0e8f4',
                color: tamamlandi || simdiki ? '#fff' : '#888',
                border: simdiki ? '2px solid #0D3B7A' : 'none',
              }}>
                {tamamlandi ? '✓' : i + 1}
              </div>
              <span style={{ fontSize: '11px', fontWeight: simdiki ? '700' : '500', color: simdiki ? '#0D3B7A' : tamamlandi ? '#3B6D11' : '#888', whiteSpace: 'nowrap' }}>
                {ad}
              </span>
            </div>
            {i < ADIMLAR.length - 1 && (
              <div style={{ flex: 1, height: '2px', background: tamamlandi ? '#3B6D11' : '#e0e8f4', margin: '0 8px', marginBottom: '20px' }} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

// ────────────────────────────────────────────────────────────────
export default function IhracatSihirbazi() {
  const [adim, setAdim] = useState(0);

  // Adım 1
  const [seferler, setSeferler] = useState([]);
  const [secilenSefer, setSecilenSefer] = useState(null);

  // Adım 2 — mal tablosu
  const [satirlar, setSatirlar] = useState([]);
  const [siraliIds, setSiraliIds] = useState([]);
  const [kaydetDurumu, setKaydetDurumu] = useState(null); // null | 'kaydediliyor' | 'kaydedildi'

  // Adım 2 — tek alıcı
  const [alici, setAlici] = useState({ ad: '', adres: '', vergi_no: '', telefon: '' });

  // Adım 3
  const [belgeTarihi, setBelgeTarihi] = useState(() => new Date().toISOString().slice(0, 10));

  // ── Adım 1: Seferleri yükle ────────────────────────────────────
  useEffect(() => {
    supabase
      .from('seferler')
      .select('*')
      .neq('durum', 'Teslim Edildi')
      .neq('arsivlendi', true)
      .order('created_at', { ascending: false })
      .then(({ data }) => setSeferler(data || []));
  }, []);

  // ── Adım 2: Sefer mallarını + sihirbaz verilerini çek ──────────
  const mallarıGetir = useCallback(async (seferId) => {
    const [depoRes, sihirbazRes] = await Promise.all([
      supabase
        .from('depo')
        .select('*, musteriler(ad, sehir, vergi_no, telefon)')
        .eq('sefer_id', seferId)
        .order('sira_no', { ascending: true, nullsFirst: false }),
      supabase
        .from('ihracat_sihirbaz')
        .select('*')
        .eq('sefer_id', seferId),
    ]);

    if (depoRes.error) { console.error('depo sorgu hatası:', depoRes.error); alert('Mallar yüklenemedi: ' + depoRes.error.message); return; }

    // sihirbaz verisini depo_id ile eşleştir
    const sihirbazMap = {};
    (sihirbazRes.data || []).forEach(s => { sihirbazMap[s.depo_id] = s; });

    const bugun = new Date().toISOString().slice(0, 10);
    const mallar = (depoRes.data || []).map((m) => {
      const sw = sihirbazMap[m.id] || {};
      return {
        ...m,
        fatura_no: m.fatura_no || '',
        tarih: m.fatura_tarihi || bugun,
        kap_adedi: sw.kap_adedi != null ? String(sw.kap_adedi) : (m.miktar != null ? String(m.miktar) : ''),
        net_kg: sw.net_kg != null ? String(sw.net_kg) : (m.agirlik != null ? String(m.agirlik) : ''),
        brut_kg: sw.brut_kg != null ? String(sw.brut_kg) : (m.brut_kg != null ? String(m.brut_kg) : ''),
      };
    });
    setSatirlar(mallar);
    setSiraliIds(mallar.map(m => m.id));

    // sira_no null olan satırlara başlangıç sırası ata
    const nullSirali = mallar.filter(m => m.sira_no == null);
    if (nullSirali.length > 0) {
      mallar.forEach((m, idx) => {
        if (m.sira_no == null) {
          supabase.from('depo').update({ sira_no: idx + 1 }).eq('id', m.id);
        }
      });
    }

    // Alıcı — ilk sihirbaz kaydından al
    const ilkSw = (sihirbazRes.data || [])[0];
    if (ilkSw) {
      setAlici({
        ad: ilkSw.alici_ad || '',
        adres: ilkSw.alici_adres || '',
        vergi_no: ilkSw.alici_vergi_no || '',
        telefon: ilkSw.alici_telefon || '',
      });
    }
  }, []);

  // ── Sürükle-bırak — sırayı DB'ye kaydet ───────────────────────
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 200, tolerance: 5 } }),
  );

  const handleDragEnd = useCallback(async ({ active, over }) => {
    if (!over || active.id === over.id) return;
    setSiraliIds(prev => {
      const oldIdx = prev.indexOf(active.id);
      const newIdx = prev.indexOf(over.id);
      const yeniSira = arrayMove(prev, oldIdx, newIdx);
      console.log(`[DragEnd] ${yeniSira.length} kayıt sıralanıyor...`);
      yeniSira.forEach((id, idx) => {
        supabase.from('depo').update({ sira_no: idx + 1 }).eq('id', id)
          .then(({ error }) => {
            if (error) console.error(`[DragEnd] sira_no yazılamadı (id=${id}):`, error.message);
            else console.log(`[DragEnd] id=${id} → sira_no=${idx + 1} ✓`);
          });
      });
      return yeniSira;
    });
  }, []);

  const setSatir = (id, key, val) =>
    setSatirlar(prev => prev.map(r => r.id === id ? { ...r, [key]: val } : r));

  // onBlur ile depo tablosunu güncelle (gonderici_firma, urun, fatura_no, tarih)
  const kaydetSatir = useCallback(async (id, key, val) => {
    const kolonMap = {
      fatura_no: 'fatura_no',
      gonderici_firma: 'gonderici_firma',
      urun: 'urun',
      tarih: 'fatura_tarihi',
    };
    const kolon = kolonMap[key];
    if (!kolon) return;
    await supabase.from('depo').update({ [kolon]: val || null }).eq('id', id);
  }, []);

  // ── Tümünü Kaydet butonu ───────────────────────────────────────
  const tumunuKaydet = useCallback(async () => {
    if (!secilenSefer) return;
    setKaydetDurumu('kaydediliyor');
    const satirKopya = [...satirlar];
    const upsertler = satirKopya.map(r => ({
      sefer_id: secilenSefer.id,
      depo_id: r.id,
      kap_adedi: parseFloat(r.kap_adedi) || null,
      net_kg: parseFloat(r.net_kg) || null,
      brut_kg: parseFloat(r.brut_kg) || null,
    }));
    const { error } = await supabase
      .from('ihracat_sihirbaz')
      .upsert(upsertler, { onConflict: 'sefer_id,depo_id' });
    if (error) { console.error('Kayıt hatası:', error); alert('Kaydedilemedi: ' + error.message); setKaydetDurumu(null); return; }
    setKaydetDurumu('kaydedildi');
    setTimeout(() => setKaydetDurumu(null), 2500);
  }, [satirlar, secilenSefer]);

  // Alıcı bilgilerini sihirbaz tablosuna kaydet
  const aliciKaydet = useCallback(async (yeniAlici) => {
    if (!secilenSefer || satirlar.length === 0) return;
    const upsertler = satirlar.map(r => ({
      sefer_id: secilenSefer.id,
      depo_id: r.id,
      alici_ad: yeniAlici.ad || null,
      alici_adres: yeniAlici.adres || null,
      alici_vergi_no: yeniAlici.vergi_no || null,
      alici_telefon: yeniAlici.telefon || null,
    }));
    await supabase.from('ihracat_sihirbaz').upsert(upsertler, { onConflict: 'sefer_id,depo_id' });
  }, [secilenSefer, satirlar]);

  const eksikFatura = satirlar.filter(r => !r.fatura_no?.trim()).length;

  // ── Gönderici firmaya göre grupla ──────────────────────────────
  const grupla = (satirListesi) => {
    const gruplar = {};
    satirListesi.forEach(r => {
      const firma = r.gonderici_firma?.trim() || '—';
      if (!gruplar[firma]) gruplar[firma] = [];
      gruplar[firma].push(r);
    });
    return gruplar;
  };

  // ── Excel indir ────────────────────────────────────────────────
  const excelIndir = () => {
    const XLSX = window.XLSX;
    if (!XLSX) { alert('Excel kütüphanesi yüklenmedi, sayfayı yenileyin.'); return; }
    const siralanmis = siraliIds.map(id => satirlar.find(r => r.id === id)).filter(Boolean);
    const wb = XLSX.utils.book_new();
    const ws = {};
    const merges = [];
    const R = (r, c) => XLSX.utils.encode_cell({ r, c });
    let row = 0;

    const hucre = (v, bold, bgRgb, fontSize, color) => ({
      v: v ?? '',
      t: typeof v === 'number' ? 'n' : 's',
      s: {
        font: { bold: !!bold, sz: fontSize || 11, color: color ? { rgb: color } : undefined },
        fill: bgRgb ? { patternType: 'solid', fgColor: { rgb: bgRgb } } : undefined,
        alignment: { wrapText: true, vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: 'CCCCCC' } },
          bottom: { style: 'thin', color: { rgb: 'CCCCCC' } },
          left: { style: 'thin', color: { rgb: 'CCCCCC' } },
          right: { style: 'thin', color: { rgb: 'CCCCCC' } },
        },
      },
    });

    merges.push({ s: { r: row, c: 0 }, e: { r: row, c: 6 } });
    ws[R(row, 0)] = hucre('ÇEKİ LİSTESİ', true, 'D4E8FF', 14);
    row++;

    ws[R(row, 0)] = hucre('GÖNDERİCİ:', true); ws[R(row, 1)] = hucre(GONDERICI.ad); row++;
    ws[R(row, 0)] = hucre('ADRES:', true); ws[R(row, 1)] = hucre(GONDERICI.adres); row++;
    ws[R(row, 0)] = hucre('VERGİ DAİRESİ:', true); ws[R(row, 1)] = hucre(GONDERICI.vergiDairesi);
    ws[R(row, 2)] = hucre('VERGİ NO:', true); ws[R(row, 3)] = hucre(GONDERICI.vergiNo); row++;
    ws[R(row, 0)] = hucre('TARİH:', true); ws[R(row, 1)] = hucre(belgeTarihi);
    ws[R(row, 2)] = hucre('SEFER NO:', true); ws[R(row, 3)] = hucre(secilenSefer?.sefer_no || ''); row++;
    ws[R(row, 0)] = hucre('ALICI:', true); ws[R(row, 1)] = hucre(alici.ad);
    ws[R(row, 2)] = hucre('VERGİ NO:', true); ws[R(row, 3)] = hucre(alici.vergi_no); row++;
    ws[R(row, 0)] = hucre('ADRES:', true); ws[R(row, 1)] = hucre(alici.adres);
    ws[R(row, 2)] = hucre('TEL:', true); ws[R(row, 3)] = hucre(alici.telefon); row++;
    row++;

    const basliklar = ['KAP NO', 'GÖNDERİCİ FİRMA', 'MALIN CİNSİ', 'KAP ADEDİ', 'NET KG', 'BRÜT KG', 'FATURA NO'];
    basliklar.forEach((b, c) => { ws[R(row, c)] = hucre(b, true, '0D3B7A', 11, 'FFFFFF'); });
    row++;

    const gruplar = grupla(siralanmis);
    let kapGTopam = 0, netGToplam = 0, brutGToplam = 0;
    let kapNo = 1;

    Object.entries(gruplar).forEach(([firma, satirGrubu]) => {
      merges.push({ s: { r: row, c: 0 }, e: { r: row, c: 6 } });
      ws[R(row, 0)] = hucre(`GÖNDERİCİ FİRMA: ${firma}`, true, 'E8F0FB', 11);
      row++;
      let kapGrup = 0, netGrup = 0, brutGrup = 0;
      satirGrubu.forEach((r2, i) => {
        const net = parseFloat(r2.net_kg) || 0;
        const brut = parseFloat(r2.brut_kg) || 0;
        const kap = parseFloat(r2.kap_adedi) || 0;
        kapGrup += kap; netGrup += net; brutGrup += brut;
        const altBg = i % 2 === 0 ? 'F8FBFF' : undefined;
        [kapNo++, firma, r2.urun || '', kap || '', net || '', brut || '', r2.fatura_no || ''].forEach((v, c) => {
          ws[R(row, c)] = hucre(v, false, altBg);
        });
        row++;
      });
      [hucre('GRUP TOPLAMI', true, 'DDEEFF'), hucre('', false, 'DDEEFF'), hucre('', false, 'DDEEFF'),
       hucre(kapGrup, true, 'DDEEFF'), hucre(netGrup, true, 'DDEEFF'), hucre(brutGrup, true, 'DDEEFF'), hucre('', false, 'DDEEFF')]
        .forEach((h, c) => { ws[R(row, c)] = h; });
      row++;
      kapGTopam += kapGrup; netGToplam += netGrup; brutGToplam += brutGrup;
    });

    row++;
    [['GENEL KAP ADEDİ TOPLAMI:', kapGTopam], ['NET AĞIRLIK TOPLAMI:', netGToplam + ' kg'], ['BRÜT AĞIRLIK TOPLAMI:', brutGToplam + ' kg']].forEach(([etiket, deger]) => {
      ws[R(row, 0)] = hucre(etiket, true, 'E8F0FB');
      ws[R(row, 1)] = hucre(deger, true, 'E8F0FB');
      row++;
    });

    ws['!ref'] = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: row, c: 6 } });
    ws['!cols'] = [{ wch: 10 }, { wch: 28 }, { wch: 26 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 18 }];
    ws['!merges'] = merges;

    XLSX.utils.book_append_sheet(wb, ws, 'Çeki Listesi');
    const tarihStr = belgeTarihi.replace(/-/g, '');
    XLSX.writeFile(wb, `CekiListesi_${secilenSefer?.sefer_no || 'Belirsiz'}_${tarihStr}.xlsx`);
  };

  const sifirla = () => {
    setAdim(0); setSecilenSefer(null);
    setSatirlar([]); setSiraliIds([]);
    setAlici({ ad: '', adres: '', vergi_no: '', telefon: '' });
    setBelgeTarihi(new Date().toISOString().slice(0, 10));
    setKaydetDurumu(null);
  };

  const inputSt = { padding: '8px 10px', border: '1px solid #d0d9e8', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box', background: '#fff', width: '100%' };
  const thSt = { padding: '9px 10px', background: '#0D3B7A', color: '#fff', fontSize: '12px', fontWeight: '600', textAlign: 'left', whiteSpace: 'nowrap' };
  const tdSt = { padding: '6px 8px', fontSize: '13px', verticalAlign: 'middle' };
  const labelSt = { fontSize: '11px', color: '#666', fontWeight: '600', marginBottom: '4px', textTransform: 'uppercase', display: 'block' };

  // ════════════════════════════════════════════════════════════════
  return (
    <div style={{ padding: '28px 32px', maxWidth: '1200px' }}>
      <div style={{ fontSize: '22px', fontWeight: '700', color: '#0D3B7A', marginBottom: '6px' }}>✈️ İhracat Sihirbazı</div>
      <div style={{ fontSize: '13px', color: '#888', marginBottom: '24px' }}>Çeki listesi oluştur ve Excel olarak indir</div>

      <AdimGostergesi aktif={adim} />

      {/* ══ ADIM 1: Sefer Seç ══ */}
      {adim === 0 && (
        <div style={{ background: '#fff', borderRadius: '12px', border: '1px solid #e0e8f4', padding: '24px' }}>
          <div style={{ fontSize: '15px', fontWeight: '700', color: '#0D3B7A', marginBottom: '16px' }}>Sefer Seçin</div>
          {seferler.length === 0 ? (
            <div style={{ color: '#888', fontSize: '14px' }}>Aktif sefer bulunamadı.</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {seferler.map(s => (
                <div key={s.id} onClick={() => setSecilenSefer(s)}
                  style={{
                    padding: '14px 18px', borderRadius: '8px', cursor: 'pointer',
                    border: secilenSefer?.id === s.id ? '2px solid #0D3B7A' : '1px solid #dde8f5',
                    background: secilenSefer?.id === s.id ? '#E8F0FB' : '#fafcff',
                    display: 'flex', gap: '20px', alignItems: 'center',
                  }}>
                  <span style={{ fontWeight: '700', color: '#0D3B7A', minWidth: '110px' }}>{s.sefer_no}</span>
                  <span style={{ color: '#555' }}>{s.guzergah}</span>
                  <span style={{ marginLeft: 'auto', background: '#E3F0FF', color: '#0D3B7A', padding: '3px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: '600' }}>{s.durum}</span>
                </div>
              ))}
            </div>
          )}
          <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
            <button
              disabled={!secilenSefer}
              onClick={() => { mallarıGetir(secilenSefer.id); setAdim(1); }}
              style={{ padding: '10px 28px', background: secilenSefer ? '#0D3B7A' : '#ccc', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '700', cursor: secilenSefer ? 'pointer' : 'not-allowed' }}>
              Devam →
            </button>
          </div>
        </div>
      )}

      {/* ══ ADIM 2: Fatura Bilgileri + Alıcı ══ */}
      {adim === 1 && (
        <div style={{ background: '#fff', borderRadius: '12px', border: '1px solid #e0e8f4', padding: '24px' }}>
          {/* Başlık + Kaydet butonu */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '16px', flexWrap: 'wrap' }}>
            <div style={{ fontSize: '15px', fontWeight: '700', color: '#0D3B7A' }}>Fatura Bilgileri — {secilenSefer?.sefer_no}</div>
            {eksikFatura > 0 && (
              <div style={{ background: '#FFF3CD', border: '1px solid #FFDDA0', color: '#854F0B', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' }}>
                ⚠️ {eksikFatura} eksik fatura no
              </div>
            )}
            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '10px' }}>
              {kaydetDurumu === 'kaydedildi' && (
                <span style={{ color: '#3B6D11', fontSize: '13px', fontWeight: '600' }}>✓ Kaydedildi</span>
              )}
              <button
                onClick={tumunuKaydet}
                disabled={kaydetDurumu === 'kaydediliyor'}
                style={{ padding: '8px 18px', background: kaydetDurumu === 'kaydediliyor' ? '#ccc' : '#3B6D11', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '700', cursor: kaydetDurumu === 'kaydediliyor' ? 'not-allowed' : 'pointer' }}>
                {kaydetDurumu === 'kaydediliyor' ? '⏳ Kaydediliyor...' : '💾 Değişiklikleri Kaydet'}
              </button>
            </div>
          </div>

          {satirlar.length === 0 ? (
            <div style={{ color: '#888', fontSize: '14px', padding: '20px 0' }}>Bu sefere ait depo kaydı bulunamadı.</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                  <tr>
                    <th style={{ ...thSt, width: '30px' }}></th>
                    <th style={{ ...thSt, width: '30px' }}>#</th>
                    <th style={thSt}>Gönderici Firma</th>
                    <th style={thSt}>Alıcı (Müşteri)</th>
                    <th style={thSt}>Ürün / Açıklama</th>
                    <th style={thSt}>Fatura No</th>
                    <th style={thSt}>Tarih</th>
                    <th style={thSt}>Kap Adedi</th>
                    <th style={thSt}>Net kg</th>
                    <th style={thSt}>Brüt kg</th>
                  </tr>
                </thead>
                <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                  <SortableContext items={siraliIds} strategy={verticalListSortingStrategy}>
                    <tbody>
                      {siraliIds.map((id, idx) => {
                        const r = satirlar.find(s => s.id === id);
                        if (!r) return null;
                        const eksik = !r.fatura_no?.trim();
                        return (
                          <SortableRow key={id} id={id}>
                            {(listeners) => (<>
                              <td style={{ ...tdSt, background: eksik ? '#FFF8E7' : undefined, color: '#bbb', textAlign: 'center', cursor: 'grab' }} {...listeners}>⠿</td>
                              <td style={{ ...tdSt, background: eksik ? '#FFF8E7' : undefined, color: '#999', textAlign: 'center' }}>{idx + 1}</td>
                              <td style={{ ...tdSt, background: eksik ? '#FFF8E7' : undefined }}>
                                <input value={r.gonderici_firma || ''} onChange={e => setSatir(id, 'gonderici_firma', e.target.value)} onBlur={e => kaydetSatir(id, 'gonderici_firma', e.target.value)} style={{ ...inputSt, minWidth: '110px' }} />
                              </td>
                              <td style={{ ...tdSt, background: eksik ? '#FFF8E7' : undefined, fontWeight: '500', whiteSpace: 'nowrap' }}>{r.musteriler?.ad || '—'}</td>
                              <td style={{ ...tdSt, background: eksik ? '#FFF8E7' : undefined }}>
                                <input value={r.urun || ''} onChange={e => setSatir(id, 'urun', e.target.value)} onBlur={e => kaydetSatir(id, 'urun', e.target.value)} style={{ ...inputSt, minWidth: '140px' }} />
                              </td>
                              <td style={{ ...tdSt, background: eksik ? '#FFECC0' : undefined }}>
                                <input value={r.fatura_no || ''} onChange={e => setSatir(id, 'fatura_no', e.target.value)} onBlur={e => kaydetSatir(id, 'fatura_no', e.target.value)}
                                  placeholder="Fatura No *"
                                  style={{ ...inputSt, minWidth: '110px', borderColor: eksik ? '#FFDDA0' : undefined }} />
                              </td>
                              <td style={{ ...tdSt, background: eksik ? '#FFF8E7' : undefined }}>
                                <input type="date" value={r.tarih || ''} onChange={e => { setSatir(id, 'tarih', e.target.value); kaydetSatir(id, 'tarih', e.target.value); }} style={{ ...inputSt, minWidth: '120px' }} />
                              </td>
                              <td style={{ ...tdSt, background: eksik ? '#FFF8E7' : undefined }}>
                                <input value={r.kap_adedi || ''} onChange={e => setSatir(id, 'kap_adedi', e.target.value)} style={{ ...inputSt, minWidth: '70px' }} />
                              </td>
                              <td style={{ ...tdSt, background: eksik ? '#FFF8E7' : undefined }}>
                                <input type="number" value={r.net_kg || ''} onChange={e => setSatir(id, 'net_kg', e.target.value)} style={{ ...inputSt, minWidth: '70px' }} />
                              </td>
                              <td style={{ ...tdSt, background: eksik ? '#FFF8E7' : undefined }}>
                                <input type="number" value={r.brut_kg || ''} onChange={e => setSatir(id, 'brut_kg', e.target.value)} style={{ ...inputSt, minWidth: '70px' }} />
                              </td>
                            </>)}
                          </SortableRow>
                        );
                      })}
                    </tbody>
                  </SortableContext>
                </DndContext>
              </table>
            </div>
          )}

          {/* Toplam özeti */}
          {satirlar.length > 0 && (() => {
            const topKap = satirlar.reduce((s, r) => s + (parseFloat(r.kap_adedi) || 0), 0);
            const topNet = satirlar.reduce((s, r) => s + (parseFloat(r.net_kg) || 0), 0);
            const topBrut = satirlar.reduce((s, r) => s + (parseFloat(r.brut_kg) || 0), 0);
            return (
              <div style={{ display: 'flex', gap: '16px', marginTop: '14px', flexWrap: 'wrap' }}>
                {[['Toplam Kap', topKap], ['Toplam Net kg', topNet.toFixed(2) + ' kg'], ['Toplam Brüt kg', topBrut.toFixed(2) + ' kg']].map(([lbl, val]) => (
                  <div key={lbl} style={{ background: '#E8F0FB', borderRadius: '8px', padding: '10px 18px', fontSize: '13px' }}>
                    <span style={{ color: '#666', marginRight: '8px' }}>{lbl}:</span>
                    <strong style={{ color: '#0D3B7A' }}>{val}</strong>
                  </div>
                ))}
              </div>
            );
          })()}

          {/* Alıcı bilgisi */}
          <div style={{ marginTop: '24px', padding: '18px', background: '#fafcff', border: '1px solid #dde8f5', borderRadius: '10px' }}>
            <div style={{ fontSize: '14px', fontWeight: '700', color: '#0D3B7A', marginBottom: '14px' }}>Alıcı Bilgileri</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '12px' }}>
              <div>
                <label style={labelSt}>Alıcı Adı / Ünvanı</label>
                <input value={alici.ad} onChange={e => setAlici(a => ({ ...a, ad: e.target.value }))} onBlur={() => aliciKaydet(alici)} style={inputSt} placeholder="Şirket veya kişi adı" />
              </div>
              <div>
                <label style={labelSt}>Adres</label>
                <input value={alici.adres} onChange={e => setAlici(a => ({ ...a, adres: e.target.value }))} onBlur={() => aliciKaydet(alici)} style={inputSt} placeholder="Adres" />
              </div>
              <div>
                <label style={labelSt}>Vergi No</label>
                <input value={alici.vergi_no} onChange={e => setAlici(a => ({ ...a, vergi_no: e.target.value }))} onBlur={() => aliciKaydet(alici)} style={inputSt} placeholder="Opsiyonel" />
              </div>
              <div>
                <label style={labelSt}>Telefon</label>
                <input value={alici.telefon} onChange={e => setAlici(a => ({ ...a, telefon: e.target.value }))} onBlur={() => aliciKaydet(alici)} style={inputSt} placeholder="Opsiyonel" />
              </div>
            </div>
          </div>

          <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between' }}>
            <button onClick={() => setAdim(0)} style={{ padding: '10px 20px', background: '#f0f4ff', color: '#0D3B7A', border: '1px solid #c8ddf5', borderRadius: '8px', fontSize: '14px', cursor: 'pointer' }}>← Geri</button>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              {eksikFatura > 0 && <span style={{ fontSize: '12px', color: '#854F0B' }}>Devam etmek için tüm fatura numaralarını doldurun.</span>}
              <button disabled={eksikFatura > 0} onClick={() => setAdim(2)}
                style={{ padding: '10px 28px', background: eksikFatura > 0 ? '#ccc' : '#0D3B7A', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '700', cursor: eksikFatura > 0 ? 'not-allowed' : 'pointer' }}>
                Devam →
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ══ ADIM 3: Çeki Listesi Önizleme ══ */}
      {adim === 2 && (() => {
        const siralanmis = siraliIds.map(id => satirlar.find(r => r.id === id)).filter(Boolean);
        const netToplam = siralanmis.reduce((s, r) => s + (parseFloat(r.net_kg) || 0), 0);
        const brutToplam = siralanmis.reduce((s, r) => s + (parseFloat(r.brut_kg) || 0), 0);
        const kapToplam = siralanmis.reduce((s, r) => s + (parseFloat(r.kap_adedi) || 0), 0);
        const gruplar = grupla(siralanmis);

        return (
          <div style={{ background: '#fff', borderRadius: '12px', border: '1px solid #e0e8f4', padding: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
              <div style={{ fontSize: '15px', fontWeight: '700', color: '#0D3B7A' }}>Çeki Listesi Önizleme</div>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontSize: '12px', color: '#666' }}>Belge Tarihi:</span>
                  <input type="date" value={belgeTarihi} onChange={e => setBelgeTarihi(e.target.value)} style={{ padding: '6px 10px', border: '1px solid #c8ddf5', borderRadius: '6px', fontSize: '13px' }} />
                </div>
                <button onClick={excelIndir} style={{ padding: '9px 20px', background: '#3B6D11', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' }}>📥 Excel İndir</button>
                <button onClick={sifirla} style={{ padding: '9px 16px', background: '#f0f4ff', color: '#0D3B7A', border: '1px solid #c8ddf5', borderRadius: '8px', fontSize: '13px', cursor: 'pointer' }}>🔄 Yeni Sihirbaz</button>
              </div>
            </div>

            <div style={{ border: '1px solid #dde8f5', borderRadius: '10px', padding: '20px', background: '#fafcff', fontSize: '13px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 24px', marginBottom: '12px', padding: '14px', background: '#E8F0FB', borderRadius: '8px' }}>
                <div><strong>GÖNDERİCİ:</strong> {GONDERICI.ad}</div>
                <div><strong>VERGİ NO:</strong> {GONDERICI.vergiNo} / {GONDERICI.vergiDairesi}</div>
                <div style={{ gridColumn: '1/-1' }}><strong>ADRES:</strong> {GONDERICI.adres}</div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 24px', marginBottom: '16px', padding: '14px', background: '#F8FBFF', borderRadius: '8px', border: '1px solid #e0e8f4' }}>
                <div><strong>ALICI:</strong> {alici.ad || '—'}</div>
                <div><strong>VERGİ NO:</strong> {alici.vergi_no || '—'}</div>
                <div><strong>ADRES:</strong> {alici.adres || '—'}</div>
                <div><strong>TEL:</strong> {alici.telefon || '—'}</div>
              </div>

              {Object.entries(gruplar).map(([firma, grup]) => {
                const gKap = grup.reduce((s, r) => s + (parseFloat(r.kap_adedi) || 0), 0);
                const gNet = grup.reduce((s, r) => s + (parseFloat(r.net_kg) || 0), 0);
                const gBrut = grup.reduce((s, r) => s + (parseFloat(r.brut_kg) || 0), 0);
                return (
                  <div key={firma} style={{ marginBottom: '16px' }}>
                    <div style={{ background: '#E8F0FB', padding: '7px 12px', fontWeight: '700', fontSize: '12px', color: '#0D3B7A', borderRadius: '6px 6px 0 0', border: '1px solid #c8ddf5' }}>
                      GÖNDERİCİ FİRMA: {firma}
                    </div>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          {['KAP NO', 'MALIN CİNSİ', 'KAP ADEDİ', 'NET KG', 'BRÜT KG', 'FATURA NO', 'TARİH'].map(h => (
                            <th key={h} style={{ padding: '7px 10px', background: '#1a4d8f', color: '#fff', fontSize: '11px', fontWeight: '600', textAlign: 'left', border: '1px solid #0a2d5e' }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {grup.map((r, i) => (
                          <tr key={r.id} style={{ background: i % 2 === 0 ? '#F8FBFF' : '#fff' }}>
                            {[i + 1, r.urun, r.kap_adedi, r.net_kg, r.brut_kg, r.fatura_no, r.tarih].map((v, ci) => (
                              <td key={ci} style={{ padding: '6px 10px', fontSize: '12px', border: '1px solid #e8eef5', color: '#333' }}>{v || '—'}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr style={{ background: '#DDEEFF' }}>
                          <td colSpan={2} style={{ padding: '6px 10px', fontWeight: '700', fontSize: '11px', border: '1px solid #c8ddf5' }}>GRUP TOPLAMI</td>
                          <td style={{ padding: '6px 10px', fontWeight: '700', fontSize: '11px', border: '1px solid #c8ddf5' }}>{gKap}</td>
                          <td style={{ padding: '6px 10px', fontWeight: '700', fontSize: '11px', border: '1px solid #c8ddf5' }}>{gNet.toFixed(2)} kg</td>
                          <td style={{ padding: '6px 10px', fontWeight: '700', fontSize: '11px', border: '1px solid #c8ddf5' }}>{gBrut.toFixed(2)} kg</td>
                          <td colSpan={2} style={{ border: '1px solid #c8ddf5' }}></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                );
              })}

              <div style={{ display: 'flex', gap: '12px', marginTop: '8px', flexWrap: 'wrap' }}>
                {[['Toplam Kap', kapToplam], ['Toplam Net', netToplam.toFixed(2) + ' kg'], ['Toplam Brüt', brutToplam.toFixed(2) + ' kg']].map(([lbl, val]) => (
                  <div key={lbl} style={{ background: '#E8F0FB', borderRadius: '8px', padding: '10px 20px', fontWeight: '700', fontSize: '13px', color: '#0D3B7A', border: '1px solid #c8ddf5' }}>
                    {lbl}: {val}
                  </div>
                ))}
              </div>
            </div>

            <div style={{ marginTop: '20px' }}>
              <button onClick={() => setAdim(1)} style={{ padding: '10px 20px', background: '#f0f4ff', color: '#0D3B7A', border: '1px solid #c8ddf5', borderRadius: '8px', fontSize: '14px', cursor: 'pointer' }}>← Geri</button>
            </div>
          </div>
        );
      })()}
    </div>
  );
}
